<template>
  <div id="app">
    <template v-if="isLoggedIn == false">
      <router-view />
    </template>
    <template v-else>
      <header-view />
      <main>
        <div class="container main-container">
          <router-view />
        </div>
      </main>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import HeaderView from '@/components/Header.vue';

export default {
  components: {
    HeaderView,
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  },
  methods: {
    ...mapActions('auth', ['injectAxiosInterceptor']),
  },
  mounted() {
    this.injectAxiosInterceptor();
  },
};
</script>

<style lang="sass">
@import ~bulma/bulma.sass
@import ~buefy/src/scss/buefy.scss
@import ~@/sass/ck-editor

html, body
  background: $white-ter

.main-container
  padding: 1.5rem
  +mobile
    padding-left: 0
    padding-right: 0
  .section
    background: $white
    + .section
      margin-top: 2rem

.b-tabs
  .tab-content
    overflow: auto
</style>
